<template>
    <fieldset class="scale_controller">
        <div class="buttons">
            <button type="button" class="out" @click="scaleDown"><img src="../../assets/img/zoom_out_icon.svg" alt="zoom_out"></button>
            <button type="button" class="reset" @click="resetScale"><img src="../../assets/img/zoom_reset_icon.svg" alt="zoom_reset"></button>
            <button type="button" class="in" @click="scaleUp"><img src="../../assets/img/zoom_in_icon.svg" alt="zoom_in"></button>
        </div>
    </fieldset>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        name: "ScaleController",
        methods: {
            ...mapMutations(["scaleUp", "scaleDown", "resetScale"]),
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    .scale_controller{
        text-align: center;
        margin-right: 10px;
        padding: 0;
        position: absolute;
        left: 28%;
        border: none;
        &:disabled {
            opacity: 0.5;
        }
        .buttons{
            display: inline-flex;
            > * {
                @extend .clickable;
                width: 30px;
                padding: 0;
                appearance: none;
                border: none;
                background: transparent;
                img{
                    width: 100%;
                    height: auto;
                    vertical-align: middle;
                }
            }
            .reset{
                box-sizing: content-box;
                padding: 0 20px;
            }
        }
    }
    @media (max-width: 1299px) {
        .scale_controller{
            position: static;
        }
    }
    @media (max-width: 739px) {
        .scale_controller{
            .buttons{
                > * {
                    width: 20px;
                }
            }
        }
    }

</style>
